import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'frontend_apis-uplt_debug_event_logging-action_category_unknown';

/**
 * Event containing debug information for UPLT
1. name,
2. loadType,
3. status,
4. pathname,
5. search,
6. userToken,
7. isDesktopAndAbove,
8. isMobile,
9. debugInfo
 */
export function trackFrontendApisUpltDebugEventLogging(
  name: string,
  loadType2: string,
  status3: string,
  pathname4: string,
  search5: string,
  userToken6: string,
  isDesktopAndAbove7: string,
  isMobile8: string,
  debugInfo9: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      name,
      loadType2,
      status3,
      pathname4,
      search5,
      userToken6,
      isDesktopAndAbove7,
      isMobile8,
      debugInfo9,
    },
  });
}
